import React, { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import { getFileUploadStatus, uploadEmployeeDetails } from "../../store/service";
import { Notification } from "../common/Notification";
const fileExtension: any = ["xlsx", "xls", "csv"];

function UploadEmployee({ setMultipleEmployee, addMultipleEmployee, setIsLoading }: any) {
    const history = useHistory();
    const goBack = () => {
        history.goBack();
    };

    let fileRef: any = useRef(null);
    let fileStatusInterval: any = null;
    const [fileName, setFileName] = useState<any>(null);
    const { register, errors, handleSubmit, setError, clearErrors } = useForm({
        mode: "onSubmit",
        reValidateMode: "onChange",
    });

    const toBase64 = (file: any) =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () =>
                resolve(
                    reader.result
                        ? reader.result
                              .toString()
                              .replace(/^data:;base64,/, "")
                              .toString()
                              .replace(/^data:.+;base64,/, "")
                        : ""
                );
            reader.onerror = (error) => reject(error);
        });

    const getFileStatus = () => {
        getFileUploadStatus()
            .then((resp) => {
                if (resp && resp.fileUploadStatus === "CGW_FILE_PROCESSING_COMPLETE") {
                    setIsLoading(false);
                    Notification({
                        type: "success",
                        title: "Success",
                        message: "File Upload Successful - Your file was processed and your employees were added to your account.",
                        duration: 5,
                    });
                    clearInterval(fileStatusInterval);
                    history.goBack();
                }
                if (resp && resp.fileUploadStatus === "FILE_UPLOAD_ERROR_DUPLICATE") {
                    clearInterval(fileStatusInterval);
                    setFileName(null);
                    setIsLoading(false);
                    Notification({
                        type: "error",
                        title: "Error",
                        message: "File Upload Failed - Please ensure each employee is only listed once and try again.",
                        duration: 5,
                    });
                }
                if (resp && resp.fileUploadStatus === "FILE_UPLOAD_ERROR") {
                    clearInterval(fileStatusInterval);
                    setFileName(null);
                    setIsLoading(false);
                    Notification({
                        type: "error",
                        title: "Error",
                        message: "File Upload Failed - Please ensure you properly filled out the employee file and try again.",
                        duration: 5,
                    });
                }
            })
            .catch((err) => {
                setIsLoading(false);
                Notification({
                    type: "error",
                    title: "Error",
                    message: err,
                    duration: 5,
                });
            });
    };

    const onSubmit = async (uploadFile: any) => {
        if (fileName) {
            setIsLoading(true);
            const fileContent = await toBase64(fileName);
            const today = new Date();
            let reqData = {
                SMBFileInfo: {
                    FileContent: fileContent,
                    Label: fileName.name,
                    CreatedDate: today.toISOString(),
                },
            };
            uploadEmployeeDetails(reqData)
                .then((res) => {
                    if (res && res.hasError) {
                        Notification({
                            type: "error",
                            title: "Error",
                            message: res.errors[0],
                            duration: 5,
                        });
                    } else {
                        fileStatusInterval = setInterval(() => {
                            getFileStatus();
                        }, 5000);
                    }
                })
                .catch((err) => {
                    Notification({
                        type: "error",
                        title: "Error",
                        message: err,
                        duration: 5,
                    });
                });
        }
    };

    const handleUpload = () => {
        if (fileRef.current) {
            fileRef.current.click();
        }
    };

    useEffect(() => {
        setError("file", {
            type: "manual",
            message: "",
        });
    }, []);

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <fieldset className="form-row inline">
                <div className="row">
                    <div className="col-xs-12 col-sm-4 col-no-gutter" style={{ display: "flex" }}>
                        <span className="employee-upload-count">1.</span>
                        <legend className="legend-label">Download and Complete the Employees Upload</legend>
                    </div>
                    <div className="form-input col-xs-12 col-sm-8 col-no-gutter flex-center">
                        <div className="form-input col-xs-5 col-sm-3 col-no-gutter">
                            <a className="btn-default btn-secondary-outline" href="doc/EmployeeDetailsTemplate.csv" download="" target="_blank">
                                <span className="btn-text">Sample .csv File</span>
                            </a>
                        </div>
                        <div className="form-input col-xs-5 col-sm-3 col-no-gutter" style={{ marginLeft: 5 }}>
                            <a className="btn-default btn-secondary-outline" href="doc/EmployeeDetailsTemplate.xlsx" download="" target="_blank">
                                <span className="btn-text">Sample .xlsx File</span>
                            </a>
                        </div>
                    </div>
                </div>
            </fieldset>
            <fieldset className="form-row inline ptb-2">
                <div className="row">
                    <div className="col-xs-12 col-sm-4 col-no-gutter" style={{ display: "flex" }}>
                        <span className="employee-upload-count">2.</span>
                        <legend className="legend-label">Upload Your .csv or .xlsx File</legend>
                    </div>
                    <div className="col-xs-12 col-sm-4 col-no-gutter">
                        <div className="row">
                            <div className="col-xs-12 col-no-gutter">
                                <div className={errors["file"] ? "form-row row status-error" : "form-row row"}>
                                    <div className="form-row row">
                                        <div className="form-label sr-only col-xs-12 col-no-gutter">
                                            <label htmlFor="label-upload-file">Upload Your .csv or .xlsx File</label>
                                        </div>
                                        <div className="form-input col-xs-12 col-no-gutter">
                                            <button type="button" className="btn-default btn-secondary-outline" onClick={handleUpload}>
                                                <span className="btn-text">{fileName ? fileName.name : "Browse File"}</span>
                                            </button>

                                            <input
                                                type="file"
                                                id="file"
                                                style={{ display: "none" }}
                                                className="inputbox"
                                                name="file"
                                                accept=".csv, .xlsx, .xls"
                                                onChange={(e) => {
                                                    if (e.target.files && e.target.files[0]) {
                                                        if (fileExtension.includes(e.target.files[0].name.split(".")[1])) {
                                                            if (e.target.files[0].size === 0) {
                                                                Notification({
                                                                    type: "error",
                                                                    title: "Error",
                                                                    message:
                                                                        "File Upload Failed - Please ensure you properly filled out the employee file and try again.",
                                                                    duration: 5,
                                                                });
                                                            } else {
                                                                setFileName(e.target.files[0]);
                                                                clearErrors("file");
                                                            }
                                                        } else {
                                                            if (!fileName) {
                                                                setError("file", {
                                                                    type: "manual",
                                                                    message: "",
                                                                });
                                                            }
                                                            Notification({
                                                                type: "error",
                                                                title: "Error",
                                                                message: "Please choose a file of type: .xls, .csv, .xlsx",
                                                                duration: 5,
                                                            });
                                                        }
                                                    }
                                                }}
                                                ref={fileRef}
                                                {...register({
                                                    required: true,
                                                })}
                                            />

                                            {errors.file && errors.file.type === "required" && <span className="form-error">Please select a file to Upload.</span>}
                                            {errors.file && errors.file.type === "manual" && <span className="form-error">{errors.file.message}</span>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </fieldset>

            <div className="row between-xs">
                <div className="col-xs-6 col-sm-6 col-no-gutter flex-grow-null">
                    <button type="button" className="btn-default btn-secondary-outline" onClick={() => setMultipleEmployee(!addMultipleEmployee)}>
                        <span className="btn-text">Add Single Employee</span>
                    </button>
                </div>
                <div className="col-xs-6 col-sm-6 col-no-gutter flex-grow-null flex-end">
                    <button type="submit" className="btn-default btn-link btn-min-width" onClick={goBack}>
                        <span className="btn-text">Cancel</span>
                    </button>
                    <button
                        type="submit"
                        className="btn-default btn-primary btn-min-width"
                        onClick={() =>
                            window.addToDataLayer({
                                event: "Button Employee Upload Click",
                            })
                        }
                        disabled={Object.keys(errors).length !== 0}
                    >
                        <span className="btn-text">Upload</span>
                    </button>
                </div>
            </div>
        </form>
    );
}

export default UploadEmployee;
